module.exports = __webpack_public_path__ + "img/favicon.cd2c868.png";